module.exports = __webpack_public_path__ + "static/media/done.b129f085.svg";